export default "__VITE_ASSET__DsMxQaGO__"